import { WorkspaceProductPrice, } from "./SDKWorkspaceProductPrice";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceProduct {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.code = model.code;
        this.allowedInviteRoles = model.allowedInviteRoles;
        this.prices = model.prices.map((m) => new WorkspaceProductPrice(m));
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toRemote() {
        return {
            code: this.code,
            allowedInviteRoles: this.allowedInviteRoles,
            prices: this.prices.map((price) => price.toRemote()),
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceProduct(model);
    }
}
